//Variable set à la soumission du formulaire d'inscription pour ne valider l'existance du courriel à la soumission seulement
window.RegisterFormSubmit = false;

// pattern regex pour valider un numéro de téléphone
var patternTelephoneValide = /\(([0-9]{3})\)([ ])([0-9]{3})([-])([0-9]{4})/;

/**
 * vérifier le téléphone est dans un format valide
 * @param {any} telephone Numéro de téléphone
 */
function isTelephoneValide(telephone) {
	return patternTelephoneValide.test(telephone);
}

/**
 * Bout de code nécessaire pour la page préférence de communication
 */
var telephone = document.getElementById("TelephoneCellulaire");

if (telephone != null && isTelephoneValide(telephone.value)) {
	telephone.classList.add("complet");
}

$.validator.setDefaults({
	//Permet la validation de chaque champ a la perte du focus
	onfocusout: function (element) {
		//Valider tous les champs seulement si ce n'est pas suite à la soumission du formulaire d'inscription
		if (!RegisterFormSubmit) {
			$(element).valid();
		} else {
			//Reset de la variable après soumission
			RegisterFormSubmit = false;
		}
	},
	errorClass: "invalid",
	validClass: "valid",

	//Le helptext est caché quand on est dans le champs et qu'on tape les premiers caractères
	highlight: function (element, errorClass, validClass) {
		//Pour les controles MDBootstrap on ne change pa la bordure
		if (!$(element).parent().hasClass("md-form")) {
			$(element).css("border-bottom", "2px solid #ED1B24");
		} else {
			$(element).addClass("invalid");
		}

		if ($(element).parent().hasClass("w-100")) {
			$(element).parent().parent().find("small").hide();
		} else {
			$(element).parent().find("small").hide();
		}
	},
	//Helptext montré à la sortie du champ
	unhighlight: function (element, errorClass, validClass) {
		//Pour les controles MDBootstrap on ne change pas la bordure
		if (!$(element).parent().hasClass("md-form")) {
			if ($(element).hasClass("bg-blue")) {
				$(element).css("border-bottom", "1px solid lightgray");
			} else {
				$(element).css("border-bottom", "1px solid #555555");
			}
		} else {
			$(element).removeClass("invalid");
		}

		if ($(element).parent().hasClass("w-100")) {
			if (!$(element).parent().parent().find(".PswBox").is(":visible")) {
				$(element).parent().parent().find("small").show();
			}
		} else {
			if (!$(element).parent().find(".PswBox").is(":visible")) {
				$(element).parent().find("small").show();
			}
		}
	},
});

//Control MDB Champ requis
jQuery.validator.addMethod("mdbrequired", function (value, element, param) {
	if (value.length == 0) {
		$(element).removeClass("valid").addClass("invalid");
	} else {
		$(element).removeClass("invalid").addClass("valid");
	}

	return value;
});

//Validation des checkbox
jQuery.validator.addMethod("checkboxtrue", function (value, element, param) {
	return value;
});

//Validation si le email existe dans la bd
jQuery.validator.addMethod("emailcheck", function (value, element, param) {
	var result = true;

	//On valide le format du courriel avant de lancer la requête
	if (/\S+@\S+\.\S+/.test(value)) {
		var email = $("#RegisterForm").find("div #Email").val();

		var jsonData = JSON.stringify(email);

		$.ajax({
			url: "/api/account/emailused/?email=" + email,

			type: "GET",
			async: false,
			dataType: "json",
			contentType: "application/json; charset=utf-8",
			success: function (results) {
				if (results != null) {
					if (results) {
						result = false;
					} else {
						result = true;
					}
				} else {
					result = true;
				}
			},
			error: function (error) {
				result = true;
			},
		});
	} else {
		return true;
	}

	return result;
});

//Validation du code postal dans la page des renseignements personnels
jQuery.validator.addMethod("checkpostalcodeformat", function (
	value,
	element,
	param
) {
	if (
		(/^.{7}$/.test(value) &&
			/^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/.test(value)) ||
		/^$/.test(value)
	) {
		return true;
	}

	return false;
});

//Validation des numéros de téléphone domicile, travail et cellulaire dans la page des renseignements personnels
jQuery.validator.addMethod("checkphoneformat", function (
	value,
	element,
	param
) {
	var cancelButton = document.getElementById("cancelButton");

	if (cancelButton.value == "cancel") {
		return true;
	} else if (isTelephoneValide(value) || /^$/.test(value)) {
		return true;
	} else {
		return false;
	}
});

//Validation du numero de téléphone cellulaire dans la page "Mes préférences de communication"
jQuery.validator.addMethod("checkmobilephoneformat", function (
	value,
	element,
	param
) {
	return isTelephoneValide(value);
});

//Validation du poste pour le téléphone de travail
jQuery.validator.addMethod("checkworkphoneformat", function (
	value,
	element,
	param
) {
	// section pour telephone de bureau
	var TelephoneBureau = document.getElementById("TelephoneBureau");
	var TelephoneBureauValide = isTelephoneValide(TelephoneBureau.value);
	var PosteBureau = document.getElementById("PosteBureau");
	var cancelButton = document.getElementById("cancelButton");
	var spanCtrl = $('span[data-valmsg-for="PosteBureau"]');
	spanCtrl.css("font-family", "'oswald'");
	var msgError = PosteBureau.getAttribute("data-val-checkworkphoneformat");

	if (cancelButton.value == "cancel") {
		return true;
	} else if (TelephoneBureauValide) {
		PosteBureau.classList.remove("invalid");
		spanCtrl.text("");
		return true;
	} else if (/^$/.test(TelephoneBureau.value)) {
		if (!/^$/.test(PosteBureau.value)) {
			PosteBureau.classList.add("invalid");

			//Affiche le message d'erreur et rend la ligne rouge
			spanCtrl.text(msgError);

			if (element.name == "PosteBureau") {
				return false;
			}
		} else {
			PosteBureau.classList.remove("invalid");
			spanCtrl.text("");
		}

		return true;
	} else if (!TelephoneBureauValide) {
		if (!/^$/.test(PosteBureau.value)) {
			return false;
		} else {
			if (element.name == "PosteBureau") {
				return true;
			}
			return false;
		}

		return false;
	} else {
		PosteBureau.classList.add("invalid");
		//Affiche le message d'erreur et rend la ligne rouge
		spanCtrl.text(msgError);
		return false;
	}
});

//Validation des mots de passes dans l'inscription
jQuery.validator.addMethod("pwcheckinscription", function (
	value,
	element,
	param
) {
	if (
		/^[A-Za-z0-9\d !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value) &&
		/[a-z]/.test(value) &&
		/[A-Z]/.test(value) &&
		/\d/.test(value) &&
		value.length >= 8 &&
		!/[%]/.test(value) &&
		!/[<]/.test(value) &&
		!/[>]/.test(value)
	) {
		return true;
	}
});

//Validation des mots de passes
jQuery.validator.addMethod("pwcheck", function (value, element, param) {
	if (
		/^[A-Za-z0-9\d !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value) &&
		/[a-z]/.test(value) &&
		/[A-Z]/.test(value) &&
		/\d/.test(value) &&
		value.length >= 8
	) {
		return true;
	}
});

//Validation des champs contre les robots
jQuery.validator.addMethod("checkr", function (value, element, param) {
	return value;
});

//Validation du code postal si la case donneur est cochée
jQuery.validator.addMethod("donorcp", function (value, element, param) {
	return value;
});

//Validation de la date de naissance si le donneur est coché
jQuery.validator.addMethod("donorbirth", function (value, element, param) {
	if (CurrentLanguage == "EN") {
		return /^\s*(3[01]|[12][0-9]|0?[1-9])\-(1[012]|0?[1-9])\-((?:19|20)\d{2})\s*$/.test(
			value
		);
	} else {
		return /^(?:(?:0?[13578]|1[02])|(?:0?[469]|11)(?!\/31)|(?:0?2)(?:(?!\/3[01]|\/29\/(?:(?:0[^48]|[13579][^26]|[2468][^048])00|(?:\d{2}(?:0[^48]|[13579][^26]|[2468][^048]))))))\/(?:0?[1-9]|[12][0-9]|3[01])\/\d{4}$/.test(
			value.replace("-", "/").replace("-", "/")
		);
	}
});

//Validation du numéro de donneur si le donneur est coché
jQuery.validator.addMethod("donornumber", function (value, element, param) {
	return value;
});

//Validation de la date
jQuery.validator.addMethod("datecheck", function (value, element, param) {
	return value;
});

//Fait apparaitre une boite de critères pour les mots de passe
//les critères sont validés un à un et un indicateur montre le critère en succès ou non
$("input[type=password]").on("focus", function (e) {
	//Pour ne pas que cette fonction interfere avec les champs type mot de passe qui n'on pas besoin de la boite de critère ex. confirmation de psw
	if ($(e.target).hasClass("NoPswBox")) {
		return false;
	}

	//Cette fonction n'est affiché que pour le formulaire d'inscription
	if (
		e.target.form.id == "RegisterForm" ||
		e.target.form.id == "ResetPswForm" ||
		e.target.form.id == "ChnPswForm"
	) {
		//Cache le helptext et les erreurs pour ensuite montrer la boite de critères

		$(e.target).closest(".md-form").find("small").hide();
		$(e.target).closest(".md-form").find("span.field-validation-error").hide();
		$(e.target).closest(".md-form").find(".PswBox").show();

		//A chaque touche on valide les critères pour afficher le statut
		$(e.target).on("keyup", function (e) {
			//Minimum de 8 caractères
			if ($(e.target).val().length >= 8) {
				$(e.target)
					.closest(".md-form")
					.find(".MinLength span")
					.removeClass("text-danger")
					.removeClass("fa-times")
					.addClass("text-success")
					.addClass("fa-check");
			} else {
				$(e.target)
					.closest(".md-form")
					.find(".MinLength span")
					.removeClass("text-success")
					.removeClass("fa-check")
					.addClass("text-danger")
					.addClass("fa-times");
			}

			//Contient au moins une minuscule
			if (/[a-z]/.test($(e.target).val())) {
				$(e.target)
					.closest(".md-form")
					.find(".Lower span")
					.removeClass("text-danger")
					.removeClass("fa-times")
					.addClass("text-success")
					.addClass("fa-check");
			} else {
				$(e.target)
					.closest(".md-form")
					.find(".Lower span")
					.removeClass("text-success")
					.removeClass("fa-check")
					.addClass("text-danger")
					.addClass("fa-times");
			}

			//Contient au moins une majuscule
			if (/[A-Z]/.test($(e.target).val())) {
				$(e.target)
					.closest(".md-form")
					.find(".Upper span")
					.removeClass("text-danger")
					.removeClass("fa-times")
					.addClass("text-success")
					.addClass("fa-check");
			} else {
				$(e.target)
					.closest(".md-form")
					.find(".Upper span")
					.removeClass("text-success")
					.removeClass("fa-check")
					.addClass("text-danger")
					.addClass("fa-times");
			}

			//Contient au moins un chiffre
			if (/\d/.test($(e.target).val())) {
				$(e.target)
					.closest(".md-form")
					.find(".Digit span")
					.removeClass("text-danger")
					.removeClass("fa-times")
					.addClass("text-success")
					.addClass("fa-check");
			} else {
				$(e.target)
					.closest(".md-form")
					.find(".Digit span")
					.removeClass("text-success")
					.removeClass("fa-check")
					.addClass("text-danger")
					.addClass("fa-times");
			}

			if (
				/[%]/.test($(e.target).val()) ||
				/[<]/.test($(e.target).val()) ||
				/[>]/.test($(e.target).val())
			) {
				$(e.target)
					.closest(".md-form")
					.find(".Nocar span")
					.removeClass("text-success")
					.removeClass("fa-check")
					.addClass("text-danger")
					.addClass("fa-times");
			} else {
				$(e.target)
					.closest(".md-form")
					.find(".Nocar span")
					.removeClass("text-danger")
					.removeClass("fa-times")
					.addClass("text-success")
					.addClass("fa-check");
			}

			//Toutes les conditions OK, on met la boite verte
			if (
				/^[A-Za-z0-9\d !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(
					$(e.target).val()
				) &&
				/[a-z]/.test($(e.target).val()) &&
				/[A-Z]/.test($(e.target).val()) &&
				/\d/.test($(e.target).val()) &&
				$(e.target).val().length >= 8 &&
				!/[%]/.test($(e.target).val()) &&
				!/[<]/.test($(e.target).val()) &&
				!/[>]/.test($(e.target).val())
				// /^[A-Za-z0-9\d !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(
				// 	$(e.target).val()
				// ) &&
				// /[a-z]/.test($(e.target).val()) &&
				// /[A-Z]/.test($(e.target).val()) &&
				// /\d/.test($(e.target).val()) &&
				// $(e.target).val().length >= 8
			) {
				$(e.target)
					.closest(".md-form")
					.find(".PswBox")
					.removeClass("PswBoxRed")
					.addClass("PswBoxGreen");
			} else {
				$(e.target)
					.closest(".md-form")
					.find(".PswBox")
					.removeClass("PswBoxGreen")
					.addClass("PswBoxRed");
			}
		});
	}
});

//A la sortie du champ on montre le helptext et les erreurs si il y en as, on cache la boite et on désactive l'événement sur la saisie des touches
$("input[type=password]").on("focusout", function (e) {
	$(e.target).closest(".md-form").find("small").show();
	$(e.target).closest(".md-form").find("span.field-validation-error").show();
	$(e.target).closest(".md-form").find(".PswBox").hide();
	$(e.target).off("keyup", function (e) {});
});
